import HttpRequest from '@/libs/axios'
import config from '@/config/index'
const axios = new HttpRequest(config.baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js